import { ResultCardTag } from '@comfama/comfama-ui-react';
import {
    ElasticSearch,
    ElasticSearchState,
    ElasticSearchOptions,
    BoolQueryClauses,
} from '@comfama/frontend-utils';
import { useEffect, useState, useRef } from 'react';

export interface ElasticSearchResult {
    id?: string;
    origin: string;
    category: string[] | string;
    title: string;
    description: string;
    slug: string;
    tags?: string[];
    iconType: string;
    urlImageCard?: string;
    dynamicFields?: ResultCardTag[];    
}

export default function useElasticSearch<T>(options: ElasticSearchOptions) {
    const [state, setState] = useState<ElasticSearchState<T>>({
        result: null,
        isLoading: true,
        errorMsg: null,
        currentPage: options.currentPage ?? 1,
        totalPages: 0,
        totalResults: 0,
    });

    // Guardamos la instancia en un ref para que no cambie entre renders
    const searchInstanceRef = useRef<ElasticSearch<T> | null>(null);

    if (!searchInstanceRef.current) {
        searchInstanceRef.current = new ElasticSearch<T>(options);
    }

    useEffect(() => {
        const unsubscribe = searchInstanceRef.current!.subscribe(setState);
        return unsubscribe; // Limpia suscripción al desmontar
    }, []);

    useEffect(() => {
        if (state.errorMsg) {
            console.error(`Error en hook useElasticSearch: ${state.errorMsg}`);
        }
    }, [state.errorMsg]);

    return {
        state,
        doSearch: (
            text: string,
            boolClauses?: BoolQueryClauses,
            sort?: Array<Record<string, unknown>>,
            page?: number
        ) => {
            searchInstanceRef.current!.doSearch(text, boolClauses, sort, page);
        },
        nextPage: () => searchInstanceRef.current!.nextPage(),
        prevPage: () => searchInstanceRef.current!.prevPage(),
        goToPage: (page: number) => searchInstanceRef.current!.goToPage(page),
        reset: () => searchInstanceRef.current!.reset(),
    };
}
